export const APIS = [
  {
    id: 'accounting',
    name: 'Accounting API',
  },
  {
    id: 'ats',
    name: 'ATS API',
  },
  {
    id: 'connector',
    name: 'Connector API',
  },
  {
    id: 'crm',
    name: 'CRM API',
  },
  {
    id: 'csp',
    name: 'CSP API',
  },
  {
    id: 'customer-support',
    name: 'Customer Support API',
  },
  {
    id: 'ecommerce',
    name: 'Ecommerce API',
  },
  {
    id: 'email-marketing',
    name: 'Email Marketing API',
  },
  {
    id: 'file-storage',
    name: 'File Storage API',
  },
  {
    id: 'form',
    name: 'Form API',
  },
  {
    id: 'hris',
    name: 'HRIS API',
  },
  {
    id: 'lead',
    name: 'Lead API',
  },
  {
    id: 'payroll',
    name: 'Payroll API',
  },
  {
    id: 'pos',
    name: 'POS API',
  },
  {
    id: 'proxy',
    name: 'Proxy API',
  },
  {
    id: 'script',
    name: 'Third-party scripts API',
  },
  {
    id: 'sms',
    name: 'SMS API',
  },
  {
    id: 'time-registration',
    name: 'Time Registration API',
  },
  {
    id: 'transactional-email',
    name: 'Transactional Email API',
  },
  {
    id: 'vault',
    name: 'Vault API',
  },
  {
    id: 'webhook',
    name: 'Webhook API',
  },
];
